import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { isBoolean, isNonEmptyString, isPositiveInteger, isPositiveIntegerOrZero } from "../utils/validators.js";
import { InvalidParameterError } from "../utils/errors/index.js";
export function getEntries(_x) {
  return _getEntries.apply(this, arguments);
}

function _getEntries() {
  _getEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var request, userId, leaderboardInstanceId, userCentric, offset, limit, scoreBased, postProcessor, entries;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            request = _ref.request, userId = _ref.userId, leaderboardInstanceId = _ref.leaderboardInstanceId, userCentric = _ref.userCentric, offset = _ref.offset, limit = _ref.limit, scoreBased = _ref.scoreBased, postProcessor = _ref.postProcessor;

            if (isNonEmptyString(userId)) {
              _context.next = 3;
              break;
            }

            throw new InvalidParameterError(1618243978, 'Parameter "userId" must be a non-empty string.');

          case 3:
            if (isNonEmptyString(leaderboardInstanceId)) {
              _context.next = 5;
              break;
            }

            throw new InvalidParameterError(1618244000, 'Parameter "leaderboardInstanceId" must be a non-empty string.');

          case 5:
            if (!(userCentric !== undefined && !isBoolean(userCentric))) {
              _context.next = 7;
              break;
            }

            throw new InvalidParameterError(1618244439, 'Parameter "userCentric" must be a boolean.');

          case 7:
            if (!(offset !== undefined && !isPositiveIntegerOrZero(offset))) {
              _context.next = 9;
              break;
            }

            throw new InvalidParameterError(1618244485, 'Parameter "offset" must be a positive integer or zero.');

          case 9:
            if (!(limit !== undefined && !isPositiveInteger(limit))) {
              _context.next = 11;
              break;
            }

            throw new InvalidParameterError(1618244557, 'Parameter "limit" must be a positive integer > 0.');

          case 11:
            if (!(scoreBased !== undefined && !isBoolean(scoreBased))) {
              _context.next = 13;
              break;
            }

            throw new InvalidParameterError(1618244623, 'Parameter "scoreBased" must be a boolean.');

          case 13:
            _context.next = 15;
            return request({
              method: 'GET',
              path: "/api/v1/leaderboardInstances/".concat(leaderboardInstanceId, "/entries"),
              params: {
                userId: userId,
                leaderboardInstanceId: leaderboardInstanceId,
                userCentric: userCentric,
                offset: offset,
                limit: limit,
                scoreBased: scoreBased
              }
            });

          case 15:
            entries = _context.sent;
            return _context.abrupt("return", postProcessor(entries));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getEntries.apply(this, arguments);
}